import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TruckOverviewComponent } from './component/truck-overview.component';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [
    TruckOverviewComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    CommonTranslationModule,
    CommonUIModule,

    MatTableModule,
    MatSortModule
  ],
  exports: [
    TruckOverviewComponent
  ]
})
export class TruckOverviewModule { }
